// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import applicationEnvironmentEntity from './entities/application-environment.json';
import applicationEnvironmentMenu from '../pages/application-environment/menu.json';
import applicationEnvironmentFullForm from '../pages/application-environment/forms/full.json';
import applicationEnvironmentContextForm from '../pages/application-environment/forms/context.json';
import applicationEnvironmentMiniForm from '../pages/application-environment/forms/mini.json';
import applicationEnvironmentLookupForm from '../pages/application-environment/forms/lookup.json';
import applicationEnvironmentTableView from '../pages/application-environment/views/table.json';
import applicationEnvironmentCardsView from '../pages/application-environment/views/cards.json';
import applicationEnvironmentDashboardView from '../pages/application-environment/views/dashboard.json';

/** Тип запису «Середовище» зі сторінками пакета: меню, форми та подання з pages/application-environment/. */
export const applicationEnvironmentDefinition: IRecordTypeDefinition = {
  ...applicationEnvironmentEntity,
  views: assembleViewSet({
      table: applicationEnvironmentTableView,
      cards: applicationEnvironmentCardsView,
      dashboard: applicationEnvironmentDashboardView,
  }),
  form: applicationEnvironmentFullForm,
  forms: { full: applicationEnvironmentFullForm, context: applicationEnvironmentContextForm, mini: applicationEnvironmentMiniForm, lookup: applicationEnvironmentLookupForm },
  menu: applicationEnvironmentMenu,
} as IRecordTypeDefinition;
